import * as React from "react";
import { Query } from "react-apollo";
import { Row } from "reactstrap";

// GraphQL
import GetCompanyRequests from "../../GraphQL/Queries/GetCompanyRequests";

// Presentation/UI
import Loader from "../../Components/Loader/DotLoader";

// Local components
import AnnualChart from "./CustomerRequestsCharts/AnnualChart";
import WeekChart from "./CustomerRequestsCharts/WeekChart";

class CustomerRequests extends React.Component<{ companyId: string }> {
  render() {
    const { companyId } = this.props;

    return (
      <Query query={GetCompanyRequests} variables={{ id: companyId }}>
        {({ loading, error, data }) => {
          if (loading) {
            return <Loader />;
          }
          if (error) {
            return <div>There was a problem loading the reqests</div>;
          }

          const requests = data.allRequests;

          return (
            <Row
              style={{
                marginTop: "30px",
                marginBottom: "30px",
                minHeight: "300px"
              }}
            >
              <AnnualChart requests={requests} />
              <WeekChart requests={requests} />
            </Row>
          );
        }}
      </Query>
    );
  }
}

export default CustomerRequests;



// WEBPACK FOOTER //
// ./src/Containers/Reports/CustomerRequestsChartReports.tsx